/**
 * @file  vehicle/index.ts
 * @description  vehicle functions
 *
 * @author smendonca
 *
 */

import * as api from '../index';
import { GetVinDetailsResponse } from './vehicle.model';

/**
 * Gets vehicle details.
 * @param vin vehicle identifier to be fetched.
 * @returns Vehicle information.
 */
export const getVinDetails = async (vin: string): Promise<GetVinDetailsResponse> => {
  const { get } = api;
  const result: GetVinDetailsResponse = await get<GetVinDetailsResponse>(`vin-details/${vin}`);
  return result;
};
